module.exports = __webpack_public_path__ + "static/media/qubit_logo_yellow.6ea4cfa1.png";